import { useSelector, useDispatch } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './configure-store';
import type {
    RootStateNextjs,
    AppDispatchNextjs
} from 'tradera/state/configure-store-ssr';

// Use throughout our app instead of plain `useSelector` since this gets us typed state
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppSelectorNextjs: TypedUseSelectorHook<RootStateNextjs> =
    useSelector;
// Use throughout our app instead of plain `useDispatch` since it includes the thunk middleware types etc
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppDispatchNextjs: () => AppDispatchNextjs = useDispatch;
